import CampaignRoutes from './campaign'
import AccessRoutes from './access'

import { LAYOUT_PUBLIC_CAMPAIGN_ROOT, LAYOUT_PUBLIC_ACCESS_ROOT } from './navigation'

const routes = [
  {
    path: LAYOUT_PUBLIC_CAMPAIGN_ROOT,
    component: CampaignRoutes
  },
  {
    path: LAYOUT_PUBLIC_ACCESS_ROOT,
    component: AccessRoutes
  }
]

export default routes
